<common-ui-components-page-layout
  [title]="config()?.title"
  [showBackIcon]="true"
  [showBorder]="false"
>
  @if (this.config()?.mode === 'products') {
    <div class="px-plus stores-search-box surface-high-contrast py-plus">
      <ngx-search-box
        [debounceTime]="1000"
        [mode]="'section'"
        (searchTextChange)="searchEnd($event)"
        (searchEnd)="searchEnd($event)"
        [placeHolder]="'جستجو در محصولات'"
        [(searchText)]="productListService.searchText"
        #searchComponent
      ></ngx-search-box>
    </div>
  }

  <div class="px-plus my-minus">
    <daily-stores-products-sort-and-filter></daily-stores-products-sort-and-filter>
  </div>
  <div
    class="d-flex px-plus flex-wrap mt-plus justify-content-space-around"
    commonUtilitiesScrolledToEnd
    (scrolledToEnd)="loadNewPage()"
  >
    @if (products()?.length) {
      @for (product of products(); track product.documentId) {
        <daily-stores-product-preview
          (clicked)="goToProductPage($event)"
          [product]="product"
          [backgroundMode]="'back'"
          [classes]="'mb-pony'"
        ></daily-stores-product-preview>
      }
    } @else if (!productsLoading()) {
      <div class="d-flex flex-col justify-content-center align-items-center">
        <common-ui-components-no-item [title]="'هیچ کالایی پیدا نشد!'"></common-ui-components-no-item>
      </div>
    } @else {
      @for (skeleton of rangeCreator(6); track $index) {
        <daily-stores-product-preview [isLoading]="true"></daily-stores-product-preview>
      }
    }
  </div>
</common-ui-components-page-layout>
